/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Evidence_Sources_LabelInputs */

const en_directory_detail_evidence_sources_label = /** @type {(inputs: Directory_Detail_Evidence_Sources_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sources`)
};

const zh_directory_detail_evidence_sources_label = /** @type {(inputs: Directory_Detail_Evidence_Sources_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个来源`)
};

/**
* | output |
* | --- |
* | "sources" |
*
* @param {Directory_Detail_Evidence_Sources_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_evidence_sources_label = /** @type {((inputs?: Directory_Detail_Evidence_Sources_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Evidence_Sources_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_evidence_sources_label(inputs)
	return zh_directory_detail_evidence_sources_label(inputs)
});
export { directory_detail_evidence_sources_label as "directory.detail.evidence_sources_label" }